import Vue from "vue";
import Vuex from "vuex";

import user from "./components/user/store/index";
import applications from "./components/applications/store/index";
import campus from "./components/campus/store/index";
import alerts from "./components/alerts/store/index";
import question from "./components/baseQuestion/base/store/index";
import textQuestion from "./components/baseQuestion/text/store/index";
import staticDDLQuestion from "./components/baseQuestion/staticDDL/store/index";
import dynamicDDLQuestion from "./components/baseQuestion/dynamicDDL/store/index";
import checkboxQuestion from "./components/baseQuestion/checkbox/store/index";
import fileQuestion from "./components/baseQuestion/file/store/index";
import searchableDDL from "./components/baseQuestion/searchableDDL/store/index";
import searchableStaticDDL from "./components/baseQuestion/searchableStaticDDL/store/index";
import multiField from "./components/baseQuestion/multiField/store/index";
import textarea from "./components/baseQuestion/textarea/store/index";

import q_first_name from "./components/questions/q_first_name/store";
import q_middle_name from "./components/questions/q_middle_name/store";
import q_last_name from "./components/questions/q_last_name/store";
import q_gender from "./components/questions/q_gender/store";
import q_uma_mens_basketball from "./components/questions/q_uma_mens_basketball/store";
import q_essay from "./components/questions/q_essay/store";
import q_maine_resident from "./components/questions/q_maine_resident/store";
import q_maine_resident_years from "./components/questions/q_maine_resident_years/store";
import q_armed_forces_status from "./components/questions/q_armed_forces_status/store";
import q_armed_forces_status_at_enroll from "./components/questions/q_armed_forces_status_at_enroll/store";
import q_armed_forces_branch from "./components/questions/q_armed_forces_branch/store";
import q_high_school_name from "./components/questions/q_high_school_name/store";
import q_college from "./components/questions/q_college/store";
import q_college_name from "./components/questions/q_college_name/store";
import q_college_country from "./components/questions/q_college_country/store";
import q_college_city from "./components/questions/q_college_city/store";
import q_college_state from "./components/questions/q_college_state/store";
import q_college_province from "./components/questions/q_college_province/store";
import q_college_attended_start from "./components/questions/q_college_attended_start/store";
import q_college_attended_end from "./components/questions/q_college_attended_end/store";
import q_convicted_crime from "./components/questions/q_convicted_crime/store";
import q_violation_educational_institution from "./components/questions/q_violation_educational_institution/store";
import q_background_info from "./components/questions/q_background_info/store";
import q_name_suffix from "./components/questions/q_name_suffix/store";
import q_preferred_first_name from "./components/questions/q_preferred_first_name/store";
import q_other_names from "./components/questions/q_other_names/store";
import q_mailing_country from "./components/questions/q_mailing_country/store";
import q_mailing_street from "./components/questions/q_mailing_street/store";
import q_mailing_city from "./components/questions/q_mailing_city/store";
import q_mailing_state from "./components/questions/q_mailing_state/store";
import q_mailing_province from "./components/questions/q_mailing_province/store";
import q_mailing_zip from "./components/questions/q_mailing_zip/store";
import q_mailing_postal from "./components/questions/q_mailing_postal/store";
import q_home_country from "./components/questions/q_home_country/store";
import q_home_street from "./components/questions/q_home_street/store";
import q_home_city from "./components/questions/q_home_city/store";
import q_home_state from "./components/questions/q_home_state/store";
import q_home_province from "./components/questions/q_home_province/store";
import q_home_zip from "./components/questions/q_home_zip/store";
import q_home_postal from "./components/questions/q_home_postal/store";
import q_phone_home from "./components/questions/q_phone_home/store";
import q_phone_work from "./components/questions/q_phone_work/store";
import q_phone_cell from "./components/questions/q_phone_cell/store";
import q_phone_mobile from "./components/questions/q_phone_mobile/store";
import q_email from "./components/questions/q_social_security_number/store";
import q_date_of_birth from "./components/questions/q_date_of_birth/store";
import q_social_security_number from "./components/questions/q_email/store";
import q_current_citizenship_status from "./components/questions/q_current_citizenship_status/store";
import q_citizenship_country from "./components/questions/q_citizenship_country/store";
import q_alien_card_id from "./components/questions/q_alien_card_id/store";
import q_languages_spoken_home from "./components/questions/q_languages_spoken_home/store";
import q_gender_info from "./components/questions/q_gender_info/store";
import q_birth_country from "./components/questions/q_birth_country/store";
import q_race_american_indian from "./components/questions/q_race_american_indian/store";
import q_race_asian from "./components/questions/q_race_asian/store";
import q_race_african_american from "./components/questions/q_race_african_american/store";
import q_race_hispanic from "./components/questions/q_race_hispanic/store";
import q_race_pacific_islander from "./components/questions/q_race_pacific_islander/store";
import q_race_white from "./components/questions/q_race_white/store";
import q_race_franco_american from "./components/questions/q_race_franco_american/store";
import q_race_other from "./components/questions/q_race_other/store";
import q_veteran_benefits_eligible from "./components/questions/q_veteran_benefits_eligible/store";
import q_apply_financial_aid from "./components/questions/q_apply_financial_aid/store";
import q_resume from "./components/questions/q_resume/store";
import q_high_school from "./components/questions/q_high_school/store";
import q_high_school_equivalent_diploma from "./components/questions/q_high_school_equivalent_diploma/store";
import q_high_school_equivalent_diploma_date_awarded from "./components/questions/q_high_school_equivalent_diploma_date_awarded/store";
import q_sat_act_no_send from "./components/questions/q_sat_act_no_send/store";
import q_maine_community_college_reverse_transfer from "./components/questions/q_maine_community_college_reverse_transfer/store";
import q_ums_empl_dep  from "./components/questions/q_ums_empl_dep/store";
import q_ap_credits from "./components/questions/q_ap_credits/store";
import q_maine_aspirations from "./components/questions/q_maine_aspirations/store";
import q_national_merit from "./components/questions/q_national_merit/store";
import q_interested_work_credit from "./components/questions/q_interested_work_credit/store";
import q_high_school_city from "./components/questions/q_high_school_city/store";
import q_high_school_state from "./components/questions/q_high_school_state/store";
import q_high_school_country from "./components/questions/q_high_school_country/store";
import q_high_school_grad_date from "./components/questions/q_high_school_grad_date/store";
import q_high_school_province from "./components/questions/q_high_school_province/store";
import q_parent from "./components/questions/q_parent/store";
import q_parent_first_name from "./components/questions/q_parent_first_name/store";
import q_parent_last_name from "./components/questions/q_parent_last_name/store";
import q_parent_attend_college from "./components/questions/q_parent_attend_college/store";
import q_parent_college_1 from "./components/questions/q_parent_college_1/store";
import q_parent_college_2 from "./components/questions/q_parent_college_2/store";
import q_parent_degree_1 from "./components/questions/q_parent_degree_1/store";
import q_parent_degree_2 from "./components/questions/q_parent_degree_2/store";
import q_uma_year from "./components/questions/q_uma_year/store";
import q_uma_womens_cross_country from "./components/questions/q_uma_womens_cross_country/store";
import q_uma_womens_basketball from "./components/questions/q_uma_womens_basketball/store";
import q_uma_semester from "./components/questions/q_uma_semester/store";
import q_uma_mens_cross_country from "./components/questions/q_uma_mens_cross_country/store";
import q_uma_major_2 from "./components/questions/q_uma_major_2/store";
import q_uma_jobs_maine_grads from "./components/questions/q_uma_jobs_maine_grads/store";
import q_uma_major_1 from "./components/questions/q_uma_major_1/store";
import q_uma_golf from "./components/questions/q_uma_golf/store";
import q_uma_full_part_time from "./components/questions/q_uma_full_part_time/store";
import q_uma_first_year_transfer from "./components/questions/q_uma_first_year_transfer/store";
import q_uma_concentration_2 from "./components/questions/q_uma_concentration_2/store";
import q_uma_concentration_1 from "./components/questions/q_uma_concentration_1/store";
import q_uma_bowling from "./components/questions/q_uma_bowling/store";
import q_uma_baseball from "./components/questions/q_uma_baseball/store";
import q_uma_softball from "./components/questions/q_uma_softball/store";
import q_uma_minor_1 from "./components/questions/q_uma_minor_1/store";
import q_uma_minor_2 from "./components/questions/q_uma_minor_2/store";
import q_um_concentration_1 from "./components/questions/q_um_concentration_1/store";
import q_um_concentration_2 from "./components/questions/q_um_concentration_2/store";
import q_uma_on_campus_housing from "./components/questions/q_uma_on_campus_housing/store";
import q_um_first_year_transfer from "./components/questions/q_um_first_year_transfer/store";
import q_um_full_part_time from "./components/questions/q_um_full_part_time/store";
import q_um_major_1 from "./components/questions/q_um_major_1/store";
import q_um_major_2 from "./components/questions/q_um_major_2/store";
import q_um_on_campus_housing from "./components/questions/q_um_on_campus_housing/store";
import q_um_previous_apply from "./components/questions/q_um_previous_apply/store";
import q_um_semester from "./components/questions/q_um_semester/store";
import q_um_year from "./components/questions/q_um_year/store";
import q_usm_first_year_transfer from "./components/questions/q_usm_first_year_transfer/store";
import q_usm_full_part_time from "./components/questions/q_usm_full_part_time/store";
import q_usm_major_1 from "./components/questions/q_usm_major_1/store";
import q_usm_major_2 from "./components/questions/q_usm_major_2/store";
import q_usm_on_campus_housing from "./components/questions/q_usm_on_campus_housing/store";
import q_usm_semester from "./components/questions/q_usm_semester/store";
import q_usm_year from "./components/questions/q_usm_year/store";
import q_umpi_first_year_transfer from "./components/questions/q_umpi_first_year_transfer/store";
import q_umpi_full_part_time from "./components/questions/q_umpi_full_part_time/store";
import q_umpi_major_1 from "./components/questions/q_umpi_major_1/store";
import q_umpi_major_2 from "./components/questions/q_umpi_major_2/store";
import q_umpi_on_campus_housing from "./components/questions/q_umpi_on_campus_housing/store";
import q_umpi_semester from "./components/questions/q_umpi_semester/store";
import q_umpi_year from "./components/questions/q_umpi_year/store";
import q_umm_first_year_transfer from "./components/questions/q_umm_first_year_transfer/store";
import q_umm_full_part_time from "./components/questions/q_umm_full_part_time/store";
import q_umm_major_1 from "./components/questions/q_umm_major_1/store";
import q_umm_major_2 from "./components/questions/q_umm_major_2/store";
import q_umm_on_campus_housing from "./components/questions/q_umm_on_campus_housing/store";
import q_umm_semester from "./components/questions/q_umm_semester/store";
import q_umm_year from "./components/questions/q_umm_year/store";
import q_umfk_first_year_transfer from "./components/questions/q_umfk_first_year_transfer/store";
import q_umfk_full_part_time from "./components/questions/q_umfk_full_part_time/store";
import q_umfk_major_1 from "./components/questions/q_umfk_major_1/store";
import q_umfk_major_2 from "./components/questions/q_umfk_major_2/store";
import q_umfk_on_campus_housing from "./components/questions/q_umfk_on_campus_housing/store";
import q_umfk_semester from "./components/questions/q_umfk_semester/store";
import q_umfk_year from "./components/questions/q_umfk_year/store";
import q_umf_first_year_transfer from "./components/questions/q_umf_first_year_transfer/store";
import q_umf_full_part_time from "./components/questions/q_umf_full_part_time/store";
import q_umf_major_1 from "./components/questions/q_umf_major_1/store";
import q_umf_major_2 from "./components/questions/q_umf_major_2/store";
import q_umf_on_campus_housing from "./components/questions/q_umf_on_campus_housing/store";
import q_umf_semester from "./components/questions/q_umf_semester/store";
import q_umf_year from "./components/questions/q_umf_year/store";
import q_umf_previous_apply from "./components/questions/q_umf_previous_apply/store";
import q_clubs_club from "./components/questions/q_clubs_club/store";
import q_act_date_1 from "./components/questions/q_act_date_1/store";
import q_act_date_2 from "./components/questions/q_act_date_2/store";
import q_armed_forces_discharge from "./components/questions/q_armed_forces_discharge/store";
import q_armed_forces_end from "./components/questions/q_armed_forces_end/store";
import q_armed_forces_start from "./components/questions/q_armed_forces_start/store";
import q_arts from "./components/questions/q_arts/store";
import q_arts_10 from "./components/questions/q_arts_10/store";
import q_arts_11 from "./components/questions/q_arts_11/store";
import q_arts_12 from "./components/questions/q_arts_12/store";
import q_arts_9 from "./components/questions/q_arts_9/store";
import q_arts_art from "./components/questions/q_arts_art/store";
import q_arts_comments from "./components/questions/q_arts_comments/store";
import q_arts_continue from "./components/questions/q_arts_continue/store";
import q_arts_pg from "./components/questions/q_arts_pg/store";
import q_athletics from "./components/questions/q_athletics/store";
import q_athletics_10 from "./components/questions/q_athletics_10/store";
import q_athletics_11 from "./components/questions/q_athletics_11/store";
import q_athletics_12 from "./components/questions/q_athletics_12/store";
import q_athletics_9 from "./components/questions/q_athletics_9/store";
import q_athletics_athletic from "./components/questions/q_athletics_athletic/store";
import q_athletics_comments from "./components/questions/q_athletics_comments/store";
import q_athletics_continue from "./components/questions/q_athletics_continue/store";
import q_athletics_pg from "./components/questions/q_athletics_pg/store";
import q_awards from "./components/questions/q_awards/store";
import q_awards_10 from "./components/questions/q_awards_10/store";
import q_awards_11 from "./components/questions/q_awards_11/store";
import q_awards_12 from "./components/questions/q_awards_12/store";
import q_awards_9 from "./components/questions/q_awards_9/store";
import q_awards_award from "./components/questions/q_awards_award/store";
import q_awards_comments from "./components/questions/q_awards_comments/store";
import q_awards_continue from "./components/questions/q_awards_continue/store";
import q_awards_pg from "./components/questions/q_awards_pg/store";
import q_canadian_sin from "./components/questions/q_canadian_sin/store";
import q_clubs_10 from "./components/questions/q_clubs_10/store";
import q_clubs_11 from "./components/questions/q_clubs_11/store";
import q_clubs_12 from "./components/questions/q_clubs_12/store";
import q_clubs_9 from "./components/questions/q_clubs_9/store";
import q_clubs_continue from "./components/questions/q_clubs_continue/store";
import q_clubs_offices_held from "./components/questions/q_clubs_offices_held/store";
import q_clubs_pg from "./components/questions/q_clubs_pg/store";
import q_college_ceeb from "./components/questions/q_college_ceeb/store";
import q_college_credits_attempted from "./components/questions/q_college_credits_attempted/store";
import q_college_full_part_time from "./components/questions/q_college_full_part_time/store";
import q_college_grad_date from "./components/questions/q_college_grad_date/store";
import q_community from "./components/questions/q_community/store";
import q_community_10 from "./components/questions/q_community_10/store";
import q_community_11 from "./components/questions/q_community_11/store";
import q_community_12 from "./components/questions/q_community_12/store";
import q_community_9 from "./components/questions/q_community_9/store";
import q_community_activity from "./components/questions/q_community_activity/store";
import q_community_pg from "./components/questions/q_community_pg/store";
import q_family from "./components/questions/q_family/store";
import q_guardian from "./components/questions/q_guardian/store";
import q_guardian_home_country from "./components/questions/q_guardian_home_country/store";
import q_guardian_email from "./components/questions/q_guardian_email/store";
import q_guardian_first_name from "./components/questions/q_guardian_first_name/store";
import q_guardian_home_city from "./components/questions/q_guardian_home_city/store";
import q_guardian_home_province from "./components/questions/q_guardian_home_province/store";
import q_guardian_home_state from "./components/questions/q_guardian_home_state/store";
import q_guardian_home_street from "./components/questions/q_guardian_home_street/store";
import q_guardian_last_name from "./components/questions/q_guardian_last_name/store";
import q_guardian_home_postal from "./components/questions/q_guardian_home_postal/store";
import q_guardian_preferred_phone from "./components/questions/q_guardian_preferred_phone/store";
import q_guardian_suffix from "./components/questions/q_guardian_suffix/store";
import q_guardian_home_zip from "./components/questions/q_guardian_home_zip/store";
import q_height from "./components/questions/q_height/store";
import q_high_school_ceeb from "./components/questions/q_high_school_ceeb/store";
import q_high_school_end from "./components/questions/q_high_school_end/store";
import q_high_school_start from "./components/questions/q_high_school_start/store";
import q_hobbies from "./components/questions/q_hobbies/store";
import q_international_student from "./components/questions/q_international_student/store";
import q_international_birth_city from "./components/questions/q_international_birth_city/store";
import q_legal_residence from "./components/questions/q_legal_residence/store";
import q_out_of_school from "./components/questions/q_out_of_school/store";
import q_parent_address_same_applicant from "./components/questions/q_parent_address_same_applicant/store";
import q_parent_email from "./components/questions/q_parent_email/store";
import q_parent_employer from "./components/questions/q_parent_employer/store";
import q_parent_home_city from "./components/questions/q_parent_home_city/store";
import q_parent_home_country from "./components/questions/q_parent_home_country/store";
import q_parent_home_postal from "./components/questions/q_parent_home_postal/store";
import q_parent_home_province from "./components/questions/q_parent_home_province/store";
import q_parent_home_state from "./components/questions/q_parent_home_state/store";
import q_parent_home_street from "./components/questions/q_parent_home_street/store";
import q_parent_home_zip from "./components/questions/q_parent_home_zip/store";
import q_parent_occupation from "./components/questions/q_parent_occupation/store";
import q_parent_preferred_phone from "./components/questions/q_parent_preferred_phone/store";
import q_parent_suffix from "./components/questions/q_parent_suffix/store";
import q_phone_preferred from "./components/questions/q_phone_preferred/store";
import q_publications from "./components/questions/q_publications/store";
import q_publications_10 from "./components/questions/q_publications_10/store";
import q_publications_11 from "./components/questions/q_publications_11/store";
import q_publications_12 from "./components/questions/q_publications_12/store";
import q_publications_9 from "./components/questions/q_publications_9/store";
import q_publications_comments from "./components/questions/q_publications_comments/store";
import q_publications_continue from "./components/questions/q_publications_continue/store";
import q_publications_pg from "./components/questions/q_publications_pg/store";
import q_publications_publication from "./components/questions/q_publications_publication/store";
import q_relative from "./components/questions/q_relative/store";
import q_relative_campus from "./components/questions/q_relative_campus/store";
import q_relative_dates_attended from "./components/questions/q_relative_dates_attended/store";
import q_relative_grad_date from "./components/questions/q_relative_grad_date/store";
import q_relative_relationship from "./components/questions/q_relative_relationship/store";
import q_sat_date_1 from "./components/questions/q_sat_date_1/store";
import q_sat_date_2 from "./components/questions/q_sat_date_2/store";
import q_um_pre_dental from "./components/questions/q_um_pre_dental/store";
import q_um_pre_law from "./components/questions/q_um_pre_law/store";
import q_um_pre_medicine from "./components/questions/q_um_pre_medicine/store";
import q_um_pre_optometry from "./components/questions/q_um_pre_optometry/store";
import q_um_pre_pharmacy from "./components/questions/q_um_pre_pharmacy/store";
import q_um_pre_veterinary from "./components/questions/q_um_pre_veterinary/store";
import q_umf_pre_dental from "./components/questions/q_umf_pre_dental/store";
import q_umf_pre_law from "./components/questions/q_umf_pre_law/store";
import q_umf_pre_medicine from "./components/questions/q_umf_pre_medicine/store";
import q_umf_pre_optometry from "./components/questions/q_umf_pre_optometry/store";
import q_umf_pre_pharmacy from "./components/questions/q_umf_pre_pharmacy/store";
import q_umf_pre_veterinary from "./components/questions/q_umf_pre_veterinary/store";
import q_umf_pre_self_designed from "./components/questions/q_umf_pre_self_designed/store";
import q_us_visa_type from "./components/questions/q_us_visa_type/store";
import q_usm_pre_dental from "./components/questions/q_usm_pre_dental/store";
import q_usm_pre_law from "./components/questions/q_usm_pre_law/store";
import q_usm_pre_medicine from "./components/questions/q_usm_pre_medicine/store";
import q_usm_pre_optometry from "./components/questions/q_usm_pre_optometry/store";
import q_usm_pre_pharmacy from "./components/questions/q_usm_pre_pharmacy/store";
import q_usm_pre_veterinary from "./components/questions/q_usm_pre_veterinary/store";
import q_weight from "./components/questions/q_weight/store";
import q_work from "./components/questions/q_work/store";
import q_work_10 from "./components/questions/q_work_10/store";
import q_work_11 from "./components/questions/q_work_11/store";
import q_work_12 from "./components/questions/q_work_12/store";
import q_work_9 from "./components/questions/q_work_9/store";
import q_work_experience from "./components/questions/q_work_experience/store";
import q_work_pg from "./components/questions/q_work_pg/store";
import q_clubs from "./components/questions/q_clubs/store";
import q_relative_name from "./components/questions/q_relative_name/store";
import q_college_degrees_earned from "./components/questions/q_college_degrees_earned/store";
import q_college_phi_theta_kappa from "./components/questions/q_college_phi_theta_kappa/store";
import q_umfk_concentration_1 from "./components/questions/q_umfk_concentration_1/store";
import q_umfk_minor_1 from "./components/questions/q_umfk_minor_1/store";
import q_umfk_concentration_2 from "./components/questions/q_umfk_concentration_2/store";
import q_umfk_minor_2 from "./components/questions/q_umfk_minor_2/store";
import q_um_minor_1 from "./components/questions/q_um_minor_1/store";
import q_um_minor_2 from "./components/questions/q_um_minor_2/store";
import q_umpi_concentration_1 from "./components/questions/q_umpi_concentration_1/store";
import q_umpi_minor_1 from "./components/questions/q_umpi_minor_1/store";
import q_umpi_concentration_2 from "./components/questions/q_umpi_concentration_2/store";
import q_umpi_minor_2 from "./components/questions/q_umpi_minor_2/store";
import q_college_atp_cd from "./components/questions/q_college_atp_cd/store";
import q_high_school_atp_cd from "./components/questions/q_high_school_atp_cd/store";
import q_home_address_same_as_mailing from "./components/questions/q_home_address_same_as_mailing/store";
import q_umf_interested_engineering from "./components/questions/q_umf_interested_engineering/store";
import q_umm_interested_engineering from "./components/questions/q_umm_interested_engineering/store";
import q_uma_take_online_courses from "./components/questions/q_uma_take_online_courses/store";
import q_um_take_online_courses from "./components/questions/q_um_take_online_courses/store";
import q_umm_take_online_courses from "./components/questions/q_umm_take_online_courses/store";
import q_umpi_take_online_courses from "./components/questions/q_umpi_take_online_courses/store";
import q_uma_previous_apply from "./components/questions/q_uma_previous_apply/store";
import q_uma_attention_to_campus from "./components/questions/q_uma_attention_to_campus/store";
import q_umf_attention_to_campus from "./components/questions/q_umf_attention_to_campus/store";
import q_umpi_previous_apply from "./components/questions/q_umpi_previous_apply/store";
import q_umpi_attention_to_campus from "./components/questions/q_umpi_attention_to_campus/store";
import q_usm_previous_apply from "./components/questions/q_usm_previous_apply/store";
import q_usm_attention_to_campus from "./components/questions/q_usm_attention_to_campus/store";
import q_um_pre_physical_therapy from "./components/questions/q_um_pre_physical_therapy/store";
import q_umm_attention_to_campus from "./components/questions/q_umm_attention_to_campus/store";
import q_umm_previous_apply from "./components/questions/q_umm_previous_apply/store";
import q_umfk_attention_to_campus from "./components/questions/q_umfk_attention_to_campus/store";
import q_umfk_previous_apply from "./components/questions/q_umfk_previous_apply/store";
import q_umfk_jobs_maine_grads from "./components/questions/q_umfk_jobs_maine_grads/store";
import q_umf_pre_addiction from "./components/questions/q_umf_pre_addiction/store";
import q_umf_pre_alpine from "./components/questions/q_umf_pre_alpine/store";
import q_umf_pre_engineering_one_three from "./components/questions/q_umf_pre_engineering_one_three/store";
import q_umf_pre_chiropractic from "./components/questions/q_umf_pre_chiropractic/store";
import q_umf_pre_chiropractic_three_three from "./components/questions/q_umf_pre_chiropractic_three_three/store";
import q_umf_pre_engineering from "./components/questions/q_umf_pre_engineering/store";
import q_umf_pre_mba from "./components/questions/q_umf_pre_mba/store";
import q_umf_pre_occupational_therapy from "./components/questions/q_umf_pre_occupational_therapy/store";
import q_umf_pre_physical_therapy from "./components/questions/q_umf_pre_physical_therapy/store";
import q_umf_pre_english from "./components/questions/q_umf_pre_english/store";
import q_umf_pre_psychology from "./components/questions/q_umf_pre_psychology/store";
import q_umf_pre_rehab from "./components/questions/q_umf_pre_rehab/store";
import q_umf_jobs_maine_grads from "./components/questions/q_umf_jobs_maine_grads/store";
import q_umm_jobs_maine_grads from "./components/questions/q_umm_jobs_maine_grads/store";
import q_um_jobs_maine_grads from "./components/questions/q_um_jobs_maine_grads/store";
import q_usm_jobs_maine_grads from "./components/questions/q_usm_jobs_maine_grads/store";
import q_umpi_jobs_maine_grads from "./components/questions/q_umpi_jobs_maine_grads/store";
import q_um_attention_to_campus from "./components/questions/q_um_attention_to_campus/store";
import q_usm_interested_engineering from "./components/questions/q_usm_interested_engineering/store";
import q_umfk_rn_license_number from "./components/questions/q_umfk_rn_license_number/store";
import q_umfk_rn_license_state from "./components/questions/q_umfk_rn_license_state/store";
import q_umfk_major_1_session from "./components/questions/q_umfk_major_1_session/store";
import q_umfk_major_2_session from "./components/questions/q_umfk_major_2_session/store";

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		user,
		applications,
		campus,
		alerts,
		question,
		textQuestion,
		staticDDLQuestion,
		dynamicDDLQuestion,
		checkboxQuestion,
		fileQuestion,
		searchableDDL,
		multiField,
		textarea,
		searchableStaticDDL,

		q_first_name,
		q_middle_name,
		q_last_name,
		q_gender,
		q_uma_mens_basketball,
		q_essay,
		q_maine_resident,
		q_maine_resident_years,
		q_armed_forces_status,
		q_armed_forces_status_at_enroll,
		q_armed_forces_branch,
		q_high_school_name,
		q_college,
		q_college_name,
		q_college_country,
		q_college_city,
		q_college_state,
		q_college_province,
		q_college_attended_start,
		q_college_attended_end,
		q_convicted_crime,
		q_violation_educational_institution,
		q_background_info,
		q_name_suffix,
		q_preferred_first_name,
		q_other_names,
		q_mailing_country,
		q_mailing_street,
		q_mailing_city,
		q_mailing_state,
		q_mailing_province,
		q_mailing_zip,
		q_mailing_postal,
		q_home_country,
		q_home_street,
		q_home_city,
		q_home_state,
		q_home_province,
		q_home_zip,
		q_home_postal,
		q_phone_home,
		q_phone_work,
		q_phone_cell,
		q_phone_mobile,
		q_email,
		q_date_of_birth,
		q_social_security_number,
		q_current_citizenship_status,
		q_citizenship_country,
		q_alien_card_id,
		q_languages_spoken_home,
		q_gender_info,
		q_birth_country,
		q_race_american_indian,
		q_race_asian,
		q_race_african_american,
		q_race_hispanic,
		q_race_pacific_islander,
		q_race_white,
		q_race_franco_american,
		q_race_other,
		q_veteran_benefits_eligible,
		q_apply_financial_aid,
		q_resume,
		q_high_school,
		q_high_school_equivalent_diploma,
		q_high_school_equivalent_diploma_date_awarded,
		q_sat_act_no_send,
		q_ums_empl_dep,
		q_ap_credits,
		q_national_merit,
		q_maine_aspirations,
		q_maine_community_college_reverse_transfer,
		q_interested_work_credit,
		q_high_school_city,
		q_high_school_state,
		q_high_school_country,
		q_high_school_grad_date,
		q_high_school_province,
		q_parent,
		q_parent_first_name,
		q_parent_last_name,
		q_parent_attend_college,
		q_parent_college_1,
		q_parent_college_2,
		q_parent_degree_1,
		q_parent_degree_2,
		q_uma_baseball,
		q_uma_bowling,
		q_uma_concentration_1,
		q_uma_concentration_2,
		q_uma_first_year_transfer,
		q_uma_full_part_time,
		q_uma_golf,
		q_uma_jobs_maine_grads,
		q_uma_major_1,
		q_uma_major_2,
		q_uma_on_campus_housing,
		q_uma_mens_cross_country,
		q_uma_semester,
		q_uma_softball,
		q_uma_womens_basketball,
		q_uma_womens_cross_country,
		q_uma_year,
		q_uma_minor_1,
		q_uma_minor_2,
		q_um_concentration_1,
		q_um_concentration_2,
		q_um_first_year_transfer,
		q_um_full_part_time,
		q_um_major_1,
		q_um_major_2,
		q_um_on_campus_housing,
		q_um_previous_apply,
		q_um_semester,
		q_um_year,
		q_usm_first_year_transfer,
		q_usm_full_part_time,
		q_usm_major_1,
		q_usm_major_2,
		q_usm_on_campus_housing,
		q_usm_semester,
		q_usm_year,
		q_umpi_first_year_transfer,
		q_umpi_full_part_time,
		q_umpi_major_1,
		q_umpi_major_2,
		q_umpi_on_campus_housing,
		q_umpi_semester,
		q_umpi_year,
		q_umm_first_year_transfer,
		q_umm_full_part_time,
		q_umm_major_1,
		q_umm_major_2,
		q_umm_on_campus_housing,
		q_umm_semester,
		q_umm_year,
		q_umfk_first_year_transfer,
		q_umfk_full_part_time,
		q_umfk_major_1,
		q_umfk_major_2,
		q_umfk_on_campus_housing,
		q_umfk_semester,
		q_umfk_year,
		q_umf_first_year_transfer,
		q_umf_full_part_time,
		q_umf_major_1,
		q_umf_major_2,
		q_umf_on_campus_housing,
		q_umf_semester,
		q_umf_year,
		q_umf_previous_apply,
		q_clubs_club,
		q_act_date_1,
		q_act_date_2,
		q_armed_forces_discharge,
		q_armed_forces_end,
		q_armed_forces_start,
		q_arts,
		q_arts_10,
		q_arts_11,
		q_arts_12,
		q_arts_9,
		q_arts_art,
		q_arts_comments,
		q_arts_continue,
		q_arts_pg,
		q_athletics,
		q_athletics_10,
		q_athletics_11,
		q_athletics_12,
		q_athletics_9,
		q_athletics_athletic,
		q_athletics_comments,
		q_athletics_continue,
		q_athletics_pg,
		q_awards,
		q_awards_10,
		q_awards_11,
		q_awards_12,
		q_awards_9,
		q_awards_award,
		q_awards_comments,
		q_awards_continue,
		q_awards_pg,
		q_canadian_sin,
		q_clubs_10,
		q_clubs_11,
		q_clubs_12,
		q_clubs_9,
		q_clubs_continue,
		q_clubs_offices_held,
		q_clubs_pg,
		q_college_ceeb,
		q_college_credits_attempted,
		q_college_full_part_time,
		q_college_grad_date,
		q_community,
		q_community_10,
		q_community_11,
		q_community_12,
		q_community_9,
		q_community_activity,
		q_community_pg,
		q_family,
		q_guardian,
		q_guardian_home_country,
		q_guardian_email,
		q_guardian_first_name,
		q_guardian_home_city,
		q_guardian_home_province,
		q_guardian_home_state,
		q_guardian_home_street,
		q_guardian_last_name,
		q_guardian_home_postal,
		q_guardian_preferred_phone,
		q_guardian_suffix,
		q_guardian_home_zip,
		q_height,
		q_high_school_ceeb,
		q_high_school_end,
		q_high_school_start,
		q_hobbies,
		q_international_student,
		q_international_birth_city,
		q_legal_residence,
		q_out_of_school,
		q_parent_address_same_applicant,
		q_parent_email,
		q_parent_employer,
		q_parent_home_city,
		q_parent_home_country,
		q_parent_home_postal,
		q_parent_home_province,
		q_parent_home_state,
		q_parent_home_street,
		q_parent_home_zip,
		q_parent_occupation,
		q_parent_preferred_phone,
		q_parent_suffix,
		q_phone_preferred,
		q_publications,
		q_publications_10,
		q_publications_11,
		q_publications_12,
		q_publications_9,
		q_publications_comments,
		q_publications_continue,
		q_publications_pg,
		q_publications_publication,
		q_relative,
		q_relative_campus,
		q_relative_dates_attended,
		q_relative_grad_date,
		q_relative_relationship,
		q_sat_date_1,
		q_sat_date_2,
		q_um_pre_dental,
		q_um_pre_law,
		q_um_pre_medicine,
		q_um_pre_optometry,
		q_um_pre_pharmacy,
		q_um_pre_veterinary,
		q_umf_pre_dental,
		q_umf_pre_law,
		q_umf_pre_medicine,
		q_umf_pre_optometry,
		q_umf_pre_pharmacy,
		q_umf_pre_veterinary,
		q_umf_pre_self_designed,
		q_us_visa_type,
		q_usm_pre_dental,
		q_usm_pre_law,
		q_usm_pre_medicine,
		q_usm_pre_optometry,
		q_usm_pre_pharmacy,
		q_usm_pre_veterinary,
		q_weight,
		q_work,
		q_work_10,
		q_work_11,
		q_work_12,
		q_work_9,
		q_work_experience,
		q_work_pg,
		q_clubs,
		q_relative_name,
		q_college_degrees_earned,
		q_college_phi_theta_kappa,
		q_umfk_concentration_1,
		q_umfk_minor_1,
		q_umfk_concentration_2,
		q_umfk_minor_2,
		q_um_minor_1,
		q_um_minor_2,
		q_umpi_concentration_1,
		q_umpi_minor_1,
		q_umpi_concentration_2,
		q_umpi_minor_2,
		q_college_atp_cd,
		q_high_school_atp_cd,
		q_home_address_same_as_mailing,
		q_umf_interested_engineering,
		q_umm_interested_engineering,
		q_uma_take_online_courses,
		q_umm_take_online_courses,
		q_um_take_online_courses,
		q_umpi_take_online_courses,
		q_uma_previous_apply,
		q_uma_attention_to_campus,
		q_umf_attention_to_campus,
		q_umpi_previous_apply,
		q_umpi_attention_to_campus,
		q_usm_previous_apply,
		q_usm_attention_to_campus,
		q_um_pre_physical_therapy,
		q_umm_attention_to_campus,
		q_umm_previous_apply,
		q_umfk_attention_to_campus,
		q_umfk_previous_apply,
		q_umfk_jobs_maine_grads,
		q_umf_pre_addiction,
		q_umf_pre_alpine,
		q_umf_pre_engineering_one_three,
		q_umf_pre_chiropractic,
		q_umf_pre_chiropractic_three_three,
		q_umf_pre_engineering,
		q_umf_pre_mba,
		q_umf_pre_occupational_therapy,
		q_umf_pre_physical_therapy,
		q_umf_pre_english,
		q_umf_pre_psychology,
		q_umf_pre_rehab,
		q_umf_jobs_maine_grads,
		q_umm_jobs_maine_grads,
		q_um_jobs_maine_grads,
		q_usm_jobs_maine_grads,
		q_umpi_jobs_maine_grads,
		q_um_attention_to_campus,
		q_usm_interested_engineering,
		q_umfk_rn_license_number,
		q_umfk_rn_license_state,
		q_umfk_major_1_session,
		q_umfk_major_2_session
	}
});
